import { Link } from "react-router-dom";
import { waUrl, WA_DISPLAY, CONTACT_EMAIL } from "@/lib/whatsapp";

export const Footer = () => (
  <footer className="bg-brand-carbon text-gray-300" data-testid="footer">
    <div className="mt-container py-14 grid gap-10 md:grid-cols-[1.2fr_1fr_1fr]">
      <div>
        <img src="/images/menuthere-logo-full-new.svg" alt="MenuThere" className="h-10 brightness-0 invert" />
        <p className="mt-4 text-sm leading-relaxed max-w-sm">Menú digital con IA, pedidos por WhatsApp y Google Maps para restaurantes en México. 0% de comisión en todos los planes. Alta express en minutos.</p>
        <p className="mt-4 text-sm">Representante oficial México: <b className="text-white">Richard Gower</b></p>
      </div>
      <div>
        <h4 className="text-white font-heading font-bold mb-4">Enlaces</h4>
        <ul className="space-y-2.5 text-sm">
          <li><Link to="/guia" className="hover:text-brand-orange transition-colors" data-track="footer-guia" data-testid="footer-guia-link">Guía técnica paso a paso</Link></li>
          <li><a href="https://menuthere.com/" target="_blank" rel="noopener noreferrer" className="hover:text-brand-orange transition-colors" data-track="footer-dashboard" data-testid="footer-dashboard-link">Dashboard (menuthere.com)</a></li>
          <li><a href={waUrl()} target="_blank" rel="noopener noreferrer" className="hover:text-brand-orange transition-colors" data-track="footer-whatsapp" data-testid="footer-whatsapp-link">WhatsApp asesor: {WA_DISPLAY}</a></li>
          <li><a href={`mailto:${CONTACT_EMAIL}`} className="hover:text-brand-orange transition-colors" data-testid="footer-email-link">{CONTACT_EMAIL}</a></li>
        </ul>
      </div>
      <div>
        <h4 className="text-white font-heading font-bold mb-4">Aviso</h4>
        <p className="text-sm leading-relaxed">MenuThere es una plataforma independiente. No estamos afiliados a Rappi, Uber Eats, Didi Food, ni a ninguna app de delivery.</p>
      </div>
    </div>
    <div className="border-t border-white/10">
      <div className="mt-container py-6 text-xs text-gray-500 flex flex-col sm:flex-row justify-between gap-2">
        <span>© 2026 MenuThere. Todos los derechos reservados.</span>
        <span>Hecho en México para restauranteros mexicanos.</span>
      </div>
    </div>
  </footer>
);

export default Footer;
